import WebTippsConfigurationDomainNameLink from './WebTippsConfigurationDomainNameLink'

export default WebTippsConfigurationDomainNameLink
